import { render, staticRenderFns } from "./parsedMessage.vue?vue&type=template&id=777b88fa&"
import script from "./parsedMessage.vue?vue&type=script&lang=ts&"
export * from "./parsedMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports